export const ExtendedBaseCoverExtra = 'ExtendedBaseCover';
export const CoverExtra = 'Cover';
export const SignatureExtra = 'Signature';
export const PrintInStoreExtra = 'PrintInStore';
export const SmsExtra = 'Sms';
export const DeliveredDutyPaidExtra = 'DeliveredDutyPaid';
export const DeliveryGuaranteeExtra = 'DeliveryGuarantee';
export const DriverBringsLabelExtra = 'DriverBringsLabel';
export const ThirdPartyEmail = 'ThirdPartyEmail';

export const ProtectionExtraIds = [ExtendedBaseCoverExtra, CoverExtra];
export const ExtrasWithCustomUi = [ExtendedBaseCoverExtra, CoverExtra, DeliveredDutyPaidExtra];
